import { HEADER } from 'analytics/constants/ids';

import { trackClick } from 'services/Analytics';

export const trackUserProfileClick = () => trackClick(HEADER, { event_action: 'user_profile_icon' });

export const trackBurgerClick = (isOpen: boolean) =>
    trackClick(HEADER, { event_action: isOpen ? 'sidebar_open' : 'sidebar_close' });
